import React from "react";
import ReactDOMServer from "react-dom/server";
import MarkdownContent from "components/molecules/MarkdownContent";

export default function markdownToText(md = "") {
	let html = "";
	if (md.trim() !== "") {
		// Note: MarkdownContent handles HTML entity decoding during rendering,
		// so the output from renderToStaticMarkup is already decoded plain text.
		// Render the markdown using existing MarkdownContent
		html = ReactDOMServer.renderToStaticMarkup(
			<MarkdownContent content={md || ""} />
		);
	}

	// Strip all HTML tags -> plain text
	return html
		.replace(/<[^>]+>/g, "")
		.replace(/\s+/g, " ") // NOSONAR S5852 — input is server-controlled renderToStaticMarkup output, not user input
		.trim();
}
